import {
  ATTACHMENT_DOCUMENT_CATEGORY,
  CHANGE_FORM_FIELD_VALUE,
  CHANGE_SELECTED_CLAIM_NUMBER,
  CHANGE_SELECTED_MESSAGE_ID,
  CHANGE_SELECTED_TAB,
  CHANGE_STEP,
  CHOOSE_DOCUMENT,
  CHOOSE_DOCUMENT_CANCELLATION,
  CHOOSE_DOCUMENT_FAILURE,
  CHOOSE_DOCUMENT_SUCCESS,
  DOWNLOAD_ATTACHMENT,
  DOWNLOAD_ATTACHMENT_FAILURE,
  DOWNLOAD_DOCUMENT,
  DOWNLOAD_DOCUMENT_FAILURE,
  FETCH_ATTACHMENT,
  FETCH_ATTACHMENT_CANCELLED,
  FETCH_ATTACHMENT_FAILURE,
  FETCH_ATTACHMENT_SUCCESS,
  FETCH_LOSSDRAFT,
  FETCH_LOSSDRAFT_FAILURE,
  FETCH_LOSSDRAFT_SUCCESS,
  FETCH_MESSAGES,
  FETCH_MESSAGES_FAILURE,
  FETCH_MESSAGES_SUCCESS,
  FETCH_MESSAGE_DETAILS,
  FETCH_MESSAGE_DETAILS_FAILURE,
  FETCH_MESSAGE_DETAILS_SUCCESS,
  POST_MESSAGE,
  POST_MESSAGE_FAILURE,
  POST_MESSAGE_SUCCESS,
  POST_REPLY,
  POST_REPLY_FAILURE,
  POST_REPLY_SUCCESS,
  PROCESS_DOCUMENT,
  PROCESS_DOCUMENT_FAILURE,
  PROCESS_DOCUMENT_SUCCESS,
  REMOVE_ATTACHMENT,
  RESET_BANNER_ERROR,
  RESET_FORM_STATE,
  RESET_LOSS_DRAFT_STATE,
  RESET_REQUEST_STATUS,
  RESET_SERVICE_ERROR,
  RESET_STEP,
  SET_ATTACHMENT_FILE,
  SET_BANNER_ERROR,
  TOGGLE_ATTACHMENT_DRAWER,
  UPDATE_ATTACHMENTS,
  UPDATE_CLAIM_NUMBERS_READ,
  UPLOAD_ATTACHMENTS_FAILURE,
} from './constants';

export function changeFormFieldValue({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: CHANGE_FORM_FIELD_VALUE,
  };
}

export function changeSelectedClaimNumber({ claimNumber }) {
  return {
    payload: { claimNumber },
    type: CHANGE_SELECTED_CLAIM_NUMBER,
  };
}

export function changeSelectedMessageId({ messageId }) {
  return {
    payload: { messageId },
    type: CHANGE_SELECTED_MESSAGE_ID,
  };
}

export function changeSelectedTab({ selectedTab }) {
  return {
    payload: { selectedTab },
    type: CHANGE_SELECTED_TAB,
  };
}

export function changeStep(step) {
  return {
    payload: { step },
    type: CHANGE_STEP,
  };
}

export function chooseDocument({ reviewScreenName, type }) {
  return {
    payload: { reviewScreenName, type },
    type: CHOOSE_DOCUMENT,
  };
}

export function chooseDocumentCancellation() {
  return { type: CHOOSE_DOCUMENT_CANCELLATION };
}

export function chooseDocumentFailure({ bannerError }) {
  return {
    payload: { bannerError },
    type: CHOOSE_DOCUMENT_FAILURE,
  };
}

export function chooseDocumentSuccess() {
  return { type: CHOOSE_DOCUMENT_SUCCESS };
}

export function downloadAttachment(payload) {
  return {
    payload,
    type: DOWNLOAD_ATTACHMENT,
  };
}

export function downloadAttachmentFailure(error) {
  return {
    payload: { error },
    type: DOWNLOAD_ATTACHMENT_FAILURE,
  };
}

export function downloadDocument({ fileUrl }) {
  return {
    payload: { fileUrl },
    type: DOWNLOAD_DOCUMENT,
  };
}

export function downloadDocumentFailure(error) {
  return {
    payload: { error },
    type: DOWNLOAD_DOCUMENT_FAILURE,
  };
}

export function fetchAttachment(payload) {
  return {
    payload,
    type: FETCH_ATTACHMENT,
  };
}

export function fetchAttachmentCancelled() {
  return { type: FETCH_ATTACHMENT_CANCELLED };
}

export function fetchAttachmentFailure(error) {
  return {
    payload: { error },
    type: FETCH_ATTACHMENT_FAILURE,
  };
}

export function fetchAttachmentSuccess() {
  return { type: FETCH_ATTACHMENT_SUCCESS };
}

export function fetchMessageDetails({ messageId }) {
  return {
    payload: { messageId },
    type: FETCH_MESSAGE_DETAILS,
  };
}

export function fetchLossDraft(loanNumber) {
  return {
    payload: { loanNumber },
    type: FETCH_LOSSDRAFT,
  };
}

export function fetchLossDraftFailure(error) {
  return {
    payload: { error },
    type: FETCH_LOSSDRAFT_FAILURE,
  };
}

export function fetchLossDraftSuccess({
  claims,
  initialSelectedClaimReference,
  initialSelectedDisbursementOption,
}) {
  return {
    payload: {
      claims,
      initialSelectedClaimReference,
      initialSelectedDisbursementOption,
    },
    type: FETCH_LOSSDRAFT_SUCCESS,
  };
}

export function fetchMessageDetailsFailure({ error }) {
  return {
    payload: { error },
    type: FETCH_MESSAGE_DETAILS_FAILURE,
  };
}

export function fetchMessageDetailsSuccess({ messageDetails }) {
  return {
    payload: { messageDetails },
    type: FETCH_MESSAGE_DETAILS_SUCCESS,
  };
}

export function fetchMessages() {
  return { type: FETCH_MESSAGES };
}

export function fetchMessagesFailure({ error }) {
  return {
    payload: { error },
    type: FETCH_MESSAGES_FAILURE,
  };
}

export function fetchMessagesSuccess({ messages }) {
  return {
    payload: { messages },
    type: FETCH_MESSAGES_SUCCESS,
  };
}

export function postMessage({
  attachments,
  body,
  claimNumber,
  subject,
}) {
  return {
    payload: {
      attachments,
      body,
      claimNumber,
      subject,
    },
    type: POST_MESSAGE,
  };
}

export function postMessageFailure({ error, nextStep }) {
  return {
    payload: { error, nextStep },
    type: POST_MESSAGE_FAILURE,
  };
}

export function postMessageSuccess({ messageId, nextStep }) {
  return {
    payload: { messageId, nextStep },
    type: POST_MESSAGE_SUCCESS,
  };
}

export function postReply({ attachments, body, messageId }) {
  return {
    payload: {
      attachments,
      body,
      documentCategory: ATTACHMENT_DOCUMENT_CATEGORY,
      messageId,
    },
    type: POST_REPLY,
  };
}

export function postReplyFailure({ error, nextStep }) {
  return {
    payload: { error, nextStep },
    type: POST_REPLY_FAILURE,
  };
}

export function postReplySuccess({ nextStep, reply }) {
  return {
    payload: { nextStep, reply },
    type: POST_REPLY_SUCCESS,
  };
}

export function processDocument({ file, mobile, validationError }) {
  return {
    payload: { file, mobile, validationError },
    type: PROCESS_DOCUMENT,
  };
}

export function processDocumentFailure({ file, validationError } = {}) {
  return {
    payload: { file, validationError },
    type: PROCESS_DOCUMENT_FAILURE,
  };
}

export function processDocumentSuccess({ file, validationError }) {
  return {
    payload: { file, validationError },
    type: PROCESS_DOCUMENT_SUCCESS,
  };
}

export function resetServiceError({ serviceError }) {
  return {
    payload: { serviceError },
    type: RESET_SERVICE_ERROR,
  };
}

export function resetState({ stateToReset }) {
  return {
    payload: { stateToReset },
    type: RESET_LOSS_DRAFT_STATE,
  };
}
export function removeAttachment({ file, index }) {
  return {
    payload: { file, index },
    type: REMOVE_ATTACHMENT,
  };
}

export function resetBannerError() {
  return { type: RESET_BANNER_ERROR };
}

export function resetFormState({ form }) {
  return {
    payload: { form },
    type: RESET_FORM_STATE,
  };
}

export function resetRequestStatus({ requestStatus }) {
  return {
    payload: { requestStatus },
    type: RESET_REQUEST_STATUS,
  };
}

export function resetStep() {
  return { type: RESET_STEP };
}

export function setAttachmentFile(payload) {
  return {
    payload,
    type: SET_ATTACHMENT_FILE,
  };
}

export function setBannerError(payload) {
  return {
    payload,
    type: SET_BANNER_ERROR,
  };
}

export function toggleAttachmentDrawer(payload) {
  return {
    payload,
    type: TOGGLE_ATTACHMENT_DRAWER,
  };
}

export function updateAttachments({ isSubmit }) {
  return {
    payload: { isSubmit },
    type: UPDATE_ATTACHMENTS,
  };
}

export function updateClaimNumbersRead({ claimNumber }) {
  return {
    payload: { claimNumber },
    type: UPDATE_CLAIM_NUMBERS_READ,
  };
}

export function uploadAttachmentsFailure({ attachmentErrors, isMobile, isReply }) {
  return {
    payload: { attachmentErrors, isMobile, isReply },
    type: UPLOAD_ATTACHMENTS_FAILURE,
  };
}
